import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';

export function* startBreakoutRoomsSaga() {
  yield call(SignalingSocket.send, {
    event: 'startBreakoutRooms',
  });
}
